import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { resolveRouteLocale } from './routeLocale'

/** Keeps shared translated chrome aligned with the URL during client-side navigation. Initial
 * page loads are already synchronized before React mounts by bootstrapLocale(). */
export function RouteLocaleSynchronizer() {
  const { pathname } = useLocation()
  const { i18n } = useTranslation()

  useEffect(() => {
    const routeLocale = resolveRouteLocale(pathname)
    if (!routeLocale) return
    document.documentElement.lang = routeLocale
    if (i18n.resolvedLanguage !== routeLocale) void i18n.changeLanguage(routeLocale)
  }, [i18n, pathname])

  return null
}
